'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _lodash = _interopRequireDefault(require("lodash"));

require("whatwg-fetch");

var _user = _interopRequireDefault(require("../user/user"));

var _farm = _interopRequireDefault(require("../farm/farm"));

var _schub = _interopRequireDefault(require("../schub/schub"));

var _farmComment = _interopRequireDefault(require("./../farm-comment"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _deleteButtonProject = _interopRequireDefault(require("./../delete-button-project"));

var _projectState = _interopRequireDefault(require("../project-state"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _translate = _interopRequireDefault(require("../translate"));

var _conf = _interopRequireDefault(require("../../conf"));

var _gitChangesetLink = _interopRequireDefault(require("../git-changeset-link"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _projectStatus = _interopRequireDefault(require("../project-status"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var DeleteButtonAuthorised = new _authorisation.default(['admin', 'projectresponsible'], ['schub'], false)(_deleteButtonProject.default);

var SchubRelease = /*#__PURE__*/function (_React$Component) {
  _inherits(SchubRelease, _React$Component);

  function SchubRelease(props) {
    var _this;

    _classCallCheck(this, SchubRelease);

    _this = _possibleConstructorReturn(this, (SchubRelease.__proto__ || Object.getPrototypeOf(SchubRelease)).call(this, props));
    _this.state = {
      subMenuConfig: [{
        label: props.t('status'),
        anchor: 'status'
      }, {
        label: props.t('User'),
        anchor: 'user-data'
      }, {
        label: props.t('farm'),
        anchor: 'farm-data'
      }, {
        label: props.t('Projectdata'),
        anchor: 'project-data'
      }, {
        label: props.t('Projects'),
        anchor: 'other-projects'
      }],
      organisatorTypes: [{
        id: 1,
        value: props.t('own address')
      }, {
        id: 3,
        value: props.t('other address')
      }],
      locationTypes: [{
        id: 1,
        value: props.t('own farm')
      }, {
        id: 3,
        value: props.t('other farm')
      }],
      userLoaded: false,
      user: {},
      project: null,
      farm: null,
      projectLoaded: false,
      placedetails: []
    };

    if (props.getSubMenuConfig && _this.state.subMenuConfig) {
      props.getSubMenuConfig(_this.state.subMenuConfig);
    }

    _this.updateFarmData = _this.updateFarmData.bind(_assertThisInitialized(_this));
    _this.updateSchubState = _this.updateSchubState.bind(_assertThisInitialized(_this));
    _this.updateSchubForeignOrganisator = _this.updateSchubForeignOrganisator.bind(_assertThisInitialized(_this));
    _this.projectAfterLoad = _this.projectAfterLoad.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SchubRelease, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var farmId = this.props.match.params.farmId;
      fetch(_conf.default.api.schubApiUrlTemplate(this.props.i18n.language, farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (project) {
        project = _this2.projectAfterLoad(project);

        _this2.setState({
          project: project,
          projectLoaded: true
        });
      }).catch(function (err) {
        if (err.error.status === 404) {
          _this2.props.history.push('/not-found');
        }
      });
      fetch("".concat(_conf.default.api.farmApiUrlTemplate(this.props.i18n.language), "/").concat(parseInt(farmId)), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (farm) {
        _this2.setState({
          farm: farm
        });
      }).catch(function (err) {
        void 0;
      });
      fetch(_conf.default.api.userFromFarmApiUrlTemplate(this.props.i18n.language, farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (user) {
        _this2.setState(function (prev) {
          prev.user = user;
          prev.userLoaded = true;
          return prev;
        });
      });
      fetch(_conf.default.api.placedetailsApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (placedetails) {
        _this2.setState(function (prev) {
          prev.placedetails = placedetails;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
      fetch(_conf.default.api.cantonApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (cantons) {
        _this2.setState(function (prev) {
          prev.cantons = cantons;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
      fetch(_conf.default.api.salutationApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (salutations) {
        _this2.setState(function (prev) {
          prev.salutations = salutations;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
      fetch(_conf.default.api.correspondenceLanguageApiUrlTemplate(this.props.i18n.language), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (languages) {
        _this2.setState(function (prev) {
          prev.languages = languages;
          return prev;
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;

      if (!this.state.project) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-schub-release detail-view"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, t('Education on the farm'), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-list"
      }, /*#__PURE__*/_react.default.createElement(DeleteButtonAuthorised, {
        id: parseInt(this.props.match.params.farmId),
        history: this.props.history,
        urlTemplate: _conf.default.api.schubApiUrlTemplate
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "status"
      }, t('release status')), /*#__PURE__*/_react.default.createElement(_projectState.default, {
        projectKey: 'schub',
        farmId: this.props.match.params.farmId,
        projectData: this.state.project
      }), /*#__PURE__*/_react.default.createElement(_gitChangesetLink.default, {
        changesetUrl: this.state.project.changeSet,
        text: t('Schub changeset link')
      }), /*#__PURE__*/_react.default.createElement(_farmComment.default, {
        id: parseInt(this.props.match.params.farmId)
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.userLoaded && /*#__PURE__*/_react.default.createElement(_user.default, {
        name: "User",
        user: this.state.user,
        anchorId: this.state.subMenuConfig[1].anchor
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.farm ? /*#__PURE__*/_react.default.createElement(_farm.default, {
        name: "Farm",
        farm: this.state.farm,
        id: this.props.match.params.farmId,
        anchorId: this.state.subMenuConfig[2].anchor,
        updateFarmData: this.updateFarmData
      }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader loader--medium"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, this.state.projectLoaded ? /*#__PURE__*/_react.default.createElement(_schub.default, {
        id: this.props.match.params.farmId,
        t: t,
        history: this.props.history,
        name: "Schub",
        project: this.state.project,
        anchorId: this.state.subMenuConfig[3].anchor,
        placedetails: this.state.placedetails,
        languages: this.state.languages,
        updateSchubForeignOrganisator: this.updateSchubForeignOrganisator,
        updateProject: this.updateSchubState,
        cantons: this.state.cantons,
        salutations: this.state.salutations,
        projectAfterLoad: this.projectAfterLoad,
        organisatortype: [{
          id: 1,
          name: 'Eigene Adresse'
        }, {
          id: 3,
          name: 'Andere Adresse'
        }],
        locationtype: [{
          id: 1,
          name: 'Eigener Hof'
        }, {
          id: 3,
          name: 'Anderer Hof'
        }]
      }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader loader--medium"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'grid-x grid-padding-x'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'cell small-12 medium-12 large-11 xlarge-10'
      }, this.state.userLoaded && /*#__PURE__*/_react.default.createElement(_projectStatus.default, {
        userId: this.state.user.id,
        t: t,
        i18n: this.props.i18n,
        history: this.props.history,
        anchorId: 'other-projects',
        ignoreProject: 'schub'
      }))));
    }
    /**
     *
     * @param project
     */

  }, {
    key: "projectAfterLoad",

    /**
     *
     * @param project
     */
    value: function projectAfterLoad(project) {
      project = SchubRelease.removeEmptySingleRelation(project); // set default values

      if (!project.farmforeignorganisator) project.farmforeignorganizator = {
        id: -1
      };
      if (!project.ownforeignorganizator) project.ownforeignorganizator = {
        id: -1
      };
      project.organisatortype = this.state.organisatorTypes.filter(function (element) {
        return element.id === project.organisatortype;
      })[0] || {};
      project.locationtype = this.state.locationTypes.filter(function (element) {
        return element.id === project.locationtype;
      })[0] || {};
      project.placedetails = project.placedetails.map(function (entry) {
        return {
          id: entry.id,
          name: entry.description
        };
      });
      return project;
    }
    /**
     *
     * @param fieldName
     * @param value
     * @returns {Promise<Response | never>}
     */

  }, {
    key: "updateSchubForeignOrganisator",
    value: function updateSchubForeignOrganisator(fieldName, value) {
      var _this3 = this;

      return fetch(_conf.default.api.schubForeignOrganisatorApiTemplate(this.props.i18n.language), {
        credentials: 'include',
        method: 'POST'
      }).then(_fetchUtils.default.checkStatus).then(function (foreignOrganisator) {
        return _this3.setState(function (prev) {
          prev.project.foreignorganizator = foreignOrganisator;
          prev.project[fieldName] = value;
          return prev;
        });
      }).catch(console.error);
    }
    /**
     *
     * @param data
     */

  }, {
    key: "updateFarmData",
    value: function updateFarmData(data) {
      this.setState(function (prev) {
        prev.farm = _lodash.default.assign(prev.farm, data);
        return prev;
      });
    }
    /**
     *
     * @param fieldName
     * @param value
     */

  }, {
    key: "updateSchubState",
    value: function updateSchubState(fieldName, value) {
      if (fieldName === 'organisatortype' && value.id === 1) {
        this.setState(function (prev) {
          _lodash.default.set(prev.project, 'locationtype', {
            id: 1
          });
        });
      }

      this.setState(function (prev) {
        _lodash.default.set(prev.project, fieldName, value);

        return prev;
      });
    }
  }], [{
    key: "removeEmptySingleRelation",
    value: function removeEmptySingleRelation(project) {
      var singleRelations = ['foreignorganizator', 'ownforeignorganizator', 'farmforeignorganizator'];
      singleRelations.forEach(function (singleRelation) {
        var singleRelationValue = _lodash.default.get(project, singleRelation);

        if (singleRelationValue && _lodash.default.isArray(singleRelationValue) && singleRelationValue.length === 0) {
          _lodash.default.set(project, singleRelation, {});
        }
      });
      return project;
    }
  }]);

  return SchubRelease;
}(_react.default.Component);

SchubRelease.propTypes = {
  t: _propTypes.default.func.isRequired,
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      farmId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
    })
  }),
  getSubMenuConfig: _propTypes.default.func,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func
  })
};

var _default = (0, _translate.default)(SchubRelease);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/schub-release/release.js
// module id = 706
// module chunks = 0